<template>
	<div>
		<c-callout type="info">
			<p>Please continue to access {{ authResult.OrganizationName }}.</p>
		</c-callout>
		<ValidationObserver ref="observer" tag="form" class="social-login__form" novalidate @submit.prevent="handleClick">
			<c-validated-input
				ref="termsCheckbox"
				v-model="termsAccepted"
				type="checkbox"
				class="sz-2"
				rules="accept-portal-terms"
			>
				I agree to the <a v-if="authResult.TermsOfServiceLink" target="_blank" :href="authResult.TermsOfServiceLink">Terms of Service</a>{{ hasBothLinks ? ' & ' : '' }}<a v-if="authResult.PrivacyPolicyLink" target="_blank" :href="authResult.PrivacyPolicyLink">Privacy Policy</a> provided by {{ authResult.OrganizationName }}.
			</c-validated-input>
			<c-button class="button button--primary sz-4" type="submit">Continue</c-button>
		</ValidationObserver>
	</div>
</template>

<script lang="ts">
	import type { PropType } from 'vue';
	import { computed, defineComponent, ref } from 'vue';
	import CButton from '@cognitoforms/shared-components/src/components/interaction/Button.vue';
	import CValidatedInput from '@cognitoforms/shared-components/src/components/form-controls/ValidatedInput.vue';
	import CCallout from '@cognitoforms/shared-components/src/components/content/Callout.vue';
	import { type TermsOfServiceResult } from '@cognitoforms/types/server-types/services/infrastructure/authentication/terms-of-service-result';
	import { extend, ValidationObserver } from 'vee-validate';

	extend('accept-portal-terms', {
		validate: value => !!value,
		message: 'You must agree.'
	});

	export default defineComponent({
		components: { CButton, CValidatedInput, CCallout, ValidationObserver },
		props: {
			authResult: {
				type: Object as PropType<TermsOfServiceResult>,
				default: () => {}
			}
		},
		emits: ['continue'],
		setup(props, { emit }) {
			const hasBothLinks = computed(() => {
				return !!props.authResult.TermsOfServiceLink && !!props.authResult.PrivacyPolicyLink;
			});

			const termsAccepted = ref<boolean>(false);
			const observer = ref<InstanceType<typeof ValidationObserver>>(null);

			const handleClick = () => {
				if (!termsAccepted.value) {
					observer.value.validate();
					return;
				}
				emit('continue');
			};

			return {
				hasBothLinks,
				termsAccepted,
				handleClick,
				observer
			};
		}
	});
</script>